<app-help-page mainVideo="custom-data-sources"
               [tutorials]="['custom-sources', 'data-sources-adloop', 'matching']"
               [videos]="['custom-data-sources', 'add-an-automatic-data-source', 'add-an-analytics-data-source', 'organic-sources']"></app-help-page>
